import React, { type SVGProps } from 'react'

const ConfirmIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    {...props}
  >
    <path
      d="M24.8 49.6C38.4981 49.6 49.6 38.4981 49.6 24.8C49.6 11.1019 38.4981 0 24.8 0C11.1019 0 0 11.1019 0 24.8C0 38.4981 11.1019 49.6 24.8 49.6ZM32.9762 20.6053L25.2262 33.0053C24.8194 33.6544 24.1219 34.0613 23.3566 34.1C22.5913 34.1388 21.855 33.79 21.3997 33.17L16.7497 26.97C15.9747 25.9431 16.1878 24.49 17.2147 23.715C18.2416 22.94 19.6947 23.1531 20.4697 24.18L23.0853 27.6675L29.0334 18.1447C29.7116 17.0597 31.1453 16.7206 32.24 17.4084C33.3347 18.0963 33.6641 19.5203 32.9762 20.615V20.6053Z"
      fill="currentColor"
    />
  </svg>
)

export default ConfirmIcon
